export default __webpack_public_path__ + "static/media/mehmed2.0f6d0f67.png";